import { Api } from "@relode/core";
import { ClientProfileResponse } from "./clientProfileResponse";
import { ClientProfileUpdateRequest } from "./clientProfileUpdateRequest";
import { ClientValidationRequest } from "./clientValidationRequest";

const function_name = (name: string) =>
    `client.shared.backend.controllers.settings.${name}`;

export const profileService = {
    getClientProfile: async () => {
        const url = "/settings";
        const response = await Api.url(url)
            .retries(3)
            .useSignal()
            .track({ name: function_name("getClientProfile") })
            .get<ClientProfileResponse>();

        return response;
    },

    saveClientProfile: async (request: ClientProfileUpdateRequest) => {
        const url = "/settings";
        const response = await Api.url(url)
            .useSignal()
            .track({ name: function_name("saveClientProfile") })
            .body(request)
            .put<ClientProfileResponse>();
        return response;
    },

    validateProfile: async (request: ClientValidationRequest) => {
        const url = "/settings/validations";
        const result = await Api.url(url)
            .retries(3)
            .useSignal()
            .throwOnAbort()
            .track({
                name: function_name("validateClientProfilePhoneEmail"),
                data: request,
            })
            .post(request);

        return result;
    },
};
